export default __webpack_public_path__ + "static/media/affnoo-logo.d896c8c5.png";